import RowHeroWebEvent from "./RowHeroWebEvent";

export default class LoginEvent extends RowHeroWebEvent {
  constructor(
    public personId: string
  ) {
    super('LoginEvent');
  }
}